import React from "react";
import "moment/locale/pt-br";
import { numberToCurrency } from "../../../../../utils/formatters";
import { BalanceContent } from "./Styled";

type Props = {
  data: number;
};

const BalanceInfo: React.FC<Props> = ({ data }) => {
  return (
    <BalanceContent>
      Saldo atual: <span>{numberToCurrency(data)}</span>
    </BalanceContent>
  );
};

export default BalanceInfo;
